import { render, staticRenderFns } from "./OneButtonModal.vue?vue&type=template&id=21ffbef0&scoped=true&"
import script from "./OneButtonModal.vue?vue&type=script&lang=js&"
export * from "./OneButtonModal.vue?vue&type=script&lang=js&"
import style0 from "./OneButtonModal.vue?vue&type=style&index=0&id=21ffbef0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ffbef0",
  null
  
)

export default component.exports